import React, {Component} from 'react';
import {connect} from 'react-redux';
import CombinationChecking from './combination-checking';
import CombinationExposure from './combination-exposure';
import UserAgent from 'helpers/device';

class CombinationOptions extends Component {
    isGameOfTeamAbsent(teamName) {
        const {games} = this.props;

        return games.getGameByTeamName(teamName) === null;
    }

    render() {
        const {stacking} = this.props;
        const combinations = stacking.getCombinations();

        const combinationBlocks = Object.keys(combinations).map((comboKey) => {
            const combination = combinations[comboKey];

            const shouldCombinationBeSkipped =
                this.isGameOfTeamAbsent(combination.firstTeamName) ||
                this.isGameOfTeamAbsent(combination.secondTeamName);

            return shouldCombinationBeSkipped ? null : (
                <div key={comboKey} className="forced-stack-box">
                    <div className="forced-stack-top">
                        <div className="forced-stack-holder">
                            <strong className="forced-stack-text">
                                {combination.firstTeamName} <br />
                                {combination.firstTeamPlayersQuantity}
                            </strong>
                            <strong className="forced-stack-text">
                                {combination.secondTeamName} <br />
                                {combination.secondTeamPlayersQuantity}
                            </strong>
                            <CombinationChecking comboKey={comboKey} />
                            <span className="stacking-text">Stack</span>
                        </div>
                    </div>
                    <div className="forced-stack-bottom">
                        <label>Min Exp:</label>
                        <div className="percent-in">
                            <CombinationExposure comboKey={comboKey} />
                            <span className="percent">%</span>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div className={'mlb-stack-combinations'}>
                <h3>Choose stack combinations</h3>
                <div className="forced-stack-container">
                    {UserAgent.isDesktop() && (
                        <ul className="forced-stack-legend">
                            <li>Teams:</li>
                            <li>Stacking:</li>
                            <li className="exp-text">Min exposures:</li>
                        </ul>
                    )}
                    {combinationBlocks}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        singlegameForcedStacking,
        playersData: {games},
    } = state;

    return {
        stacking: singlegameForcedStacking.settings,
        games,
    };
}

export default connect(mapStatesToProps)(CombinationOptions);
